export const GET_MENU_PREVIEW = 'providers/menuMaker/MenuPreview/GET_MENU_PREVIEW';
export const GET_MENU_CATEGORY_PRODUCTS = 'providers/menuMaker/MenuPreview/GET_MENU_CATEGORY_PRODUCTS';
export const GET_MENU_PRODUCT_DETAILS = 'providers/menuMaker/MenuPreview/GET_MENU_PRODUCT_DETAILS';
export const EXPORT_MENU = 'providers/menuMaker/MenuPreview/EXPORT_MENU';
